"use strict";
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [https://neo4j.com]
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollbackTransactionResponseCodec = exports.RollbackTransactionRequestCodec = exports.CommitTransactionResponseCodec = exports.CommitTransactionRequestCodec = exports.BeginTransactionResponseCodec = exports.BeginTransactionRequestCodec = void 0;
var neo4j_driver_core_1 = require("neo4j-driver-core");
var codec_1 = require("./codec");
var BeginTransactionRequestCodec = /** @class */ (function () {
    function BeginTransactionRequestCodec(_auth, _config) {
        this._auth = _auth;
        this._config = _config;
    }
    BeginTransactionRequestCodec.of = function (auth, config) {
        return new BeginTransactionRequestCodec(auth, config);
    };
    Object.defineProperty(BeginTransactionRequestCodec.prototype, "contentType", {
        get: function () {
            return 'application/json';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionRequestCodec.prototype, "accept", {
        get: function () {
            return "".concat(codec_1.NEO4J_QUERY_CONTENT_TYPE, ", application/json");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionRequestCodec.prototype, "authorization", {
        get: function () {
            return (0, codec_1.encodeAuthToken)(this._auth);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionRequestCodec.prototype, "body", {
        get: function () {
            if (this._body != null) {
                return this._body;
            }
            this._body = (0, codec_1.encodeTransactionBody)(this._config);
            return this._body;
        },
        enumerable: false,
        configurable: true
    });
    return BeginTransactionRequestCodec;
}());
exports.BeginTransactionRequestCodec = BeginTransactionRequestCodec;
var BeginTransactionResponseCodec = /** @class */ (function () {
    function BeginTransactionResponseCodec() {
    }
    BeginTransactionResponseCodec.of = function (config, contentType, response) {
        var _a, _b;
        if (isSuccess(response)) {
            return new BeginTransactionSuccessResponseCodec(config, response);
        }
        return new BeginTransactionFailureResponseCodec(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
            (0, neo4j_driver_core_1.newError)(response.errors[0].message, 
            // TODO: REMOVE THE ?? AND .ERROR WHEN SERVER IS FIXED
            (_b = response.errors[0].code) !== null && _b !== void 0 ? _b : response.errors[0].error) :
            (0, neo4j_driver_core_1.newError)('Server replied an empty error response', neo4j_driver_core_1.error.PROTOCOL_ERROR));
    };
    Object.defineProperty(BeginTransactionResponseCodec.prototype, "error", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionResponseCodec.prototype, "id", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionResponseCodec.prototype, "expires", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionResponseCodec.prototype, "host", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    return BeginTransactionResponseCodec;
}());
exports.BeginTransactionResponseCodec = BeginTransactionResponseCodec;
var BeginTransactionSuccessResponseCodec = /** @class */ (function (_super) {
    __extends(BeginTransactionSuccessResponseCodec, _super);
    function BeginTransactionSuccessResponseCodec(_config, _response) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._response = _response;
        return _this;
    }
    Object.defineProperty(BeginTransactionSuccessResponseCodec.prototype, "error", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionSuccessResponseCodec.prototype, "id", {
        get: function () {
            return this._response.transaction.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionSuccessResponseCodec.prototype, "expires", {
        get: function () {
            return new Date(this._response.transaction.expires);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionSuccessResponseCodec.prototype, "host", {
        get: function () {
            return this._response.transaction.tx_host;
        },
        enumerable: false,
        configurable: true
    });
    return BeginTransactionSuccessResponseCodec;
}(BeginTransactionResponseCodec));
var BeginTransactionFailureResponseCodec = /** @class */ (function (_super) {
    __extends(BeginTransactionFailureResponseCodec, _super);
    function BeginTransactionFailureResponseCodec(_error) {
        var _this = _super.call(this) || this;
        _this._error = _error;
        return _this;
    }
    Object.defineProperty(BeginTransactionFailureResponseCodec.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionFailureResponseCodec.prototype, "id", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionFailureResponseCodec.prototype, "expires", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeginTransactionFailureResponseCodec.prototype, "host", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    return BeginTransactionFailureResponseCodec;
}(BeginTransactionResponseCodec));
var CommitTransactionRequestCodec = /** @class */ (function () {
    function CommitTransactionRequestCodec(_auth, _config) {
        this._auth = _auth;
        this._config = _config;
    }
    CommitTransactionRequestCodec.of = function (auth, config) {
        return new CommitTransactionRequestCodec(auth, config);
    };
    Object.defineProperty(CommitTransactionRequestCodec.prototype, "contentType", {
        get: function () {
            return 'application/json';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommitTransactionRequestCodec.prototype, "accept", {
        get: function () {
            return "".concat(codec_1.NEO4J_QUERY_CONTENT_TYPE, ", application/json");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommitTransactionRequestCodec.prototype, "body", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommitTransactionRequestCodec.prototype, "authorization", {
        get: function () {
            return (0, codec_1.encodeAuthToken)(this._auth);
        },
        enumerable: false,
        configurable: true
    });
    return CommitTransactionRequestCodec;
}());
exports.CommitTransactionRequestCodec = CommitTransactionRequestCodec;
var CommitTransactionResponseCodec = /** @class */ (function () {
    function CommitTransactionResponseCodec() {
    }
    CommitTransactionResponseCodec.of = function (config, contentType, response) {
        var _a, _b;
        if (isCommitSuccess(response)) {
            return new CommitTransactionSuccessResponseCodec(config, response);
        }
        return new CommitTransactionFailureResponseCodec(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
            (0, neo4j_driver_core_1.newError)(response.errors[0].message, 
            // TODO: REMOVE THE ?? AND .ERROR WHEN SERVER IS FIXED
            (_b = response.errors[0].code) !== null && _b !== void 0 ? _b : response.errors[0].error) :
            (0, neo4j_driver_core_1.newError)('Server replied an empty error response', neo4j_driver_core_1.error.PROTOCOL_ERROR));
    };
    Object.defineProperty(CommitTransactionResponseCodec.prototype, "error", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommitTransactionResponseCodec.prototype, "meta", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    return CommitTransactionResponseCodec;
}());
exports.CommitTransactionResponseCodec = CommitTransactionResponseCodec;
var CommitTransactionSuccessResponseCodec = /** @class */ (function (_super) {
    __extends(CommitTransactionSuccessResponseCodec, _super);
    function CommitTransactionSuccessResponseCodec(_config, _response) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._response = _response;
        return _this;
    }
    Object.defineProperty(CommitTransactionSuccessResponseCodec.prototype, "error", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommitTransactionSuccessResponseCodec.prototype, "meta", {
        get: function () {
            return {
                bookmark: this._response.bookmarks
            };
        },
        enumerable: false,
        configurable: true
    });
    return CommitTransactionSuccessResponseCodec;
}(CommitTransactionResponseCodec));
var CommitTransactionFailureResponseCodec = /** @class */ (function (_super) {
    __extends(CommitTransactionFailureResponseCodec, _super);
    function CommitTransactionFailureResponseCodec(_error) {
        var _this = _super.call(this) || this;
        _this._error = _error;
        return _this;
    }
    Object.defineProperty(CommitTransactionFailureResponseCodec.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommitTransactionFailureResponseCodec.prototype, "meta", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    return CommitTransactionFailureResponseCodec;
}(CommitTransactionResponseCodec));
var RollbackTransactionRequestCodec = /** @class */ (function () {
    function RollbackTransactionRequestCodec(_auth, _config) {
        this._auth = _auth;
        this._config = _config;
    }
    RollbackTransactionRequestCodec.of = function (auth, config) {
        return new RollbackTransactionRequestCodec(auth, config);
    };
    Object.defineProperty(RollbackTransactionRequestCodec.prototype, "body", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RollbackTransactionRequestCodec.prototype, "contentType", {
        get: function () {
            return 'application/json';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RollbackTransactionRequestCodec.prototype, "accept", {
        get: function () {
            return "".concat(codec_1.NEO4J_QUERY_CONTENT_TYPE, ", application/json");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RollbackTransactionRequestCodec.prototype, "authorization", {
        get: function () {
            return (0, codec_1.encodeAuthToken)(this._auth);
        },
        enumerable: false,
        configurable: true
    });
    return RollbackTransactionRequestCodec;
}());
exports.RollbackTransactionRequestCodec = RollbackTransactionRequestCodec;
var RollbackTransactionResponseCodec = /** @class */ (function () {
    function RollbackTransactionResponseCodec() {
    }
    RollbackTransactionResponseCodec.of = function (config, contentType, response) {
        var _a, _b;
        if (isRollbackSuccess(response)) {
            return new RollbackTransactionSuccessResponseCodec(config, response);
        }
        return new RollbackTransactionFailureResponseCodec(((_a = response.errors) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
            (0, neo4j_driver_core_1.newError)(response.errors[0].message, 
            // TODO: REMOVE THE ?? AND .ERROR WHEN SERVER IS FIXED
            (_b = response.errors[0].code) !== null && _b !== void 0 ? _b : response.errors[0].error) :
            (0, neo4j_driver_core_1.newError)('Server replied an empty error response', neo4j_driver_core_1.error.PROTOCOL_ERROR));
    };
    Object.defineProperty(RollbackTransactionResponseCodec.prototype, "error", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RollbackTransactionResponseCodec.prototype, "meta", {
        get: function () {
            throw new Error('Not implemented');
        },
        enumerable: false,
        configurable: true
    });
    return RollbackTransactionResponseCodec;
}());
exports.RollbackTransactionResponseCodec = RollbackTransactionResponseCodec;
var RollbackTransactionSuccessResponseCodec = /** @class */ (function (_super) {
    __extends(RollbackTransactionSuccessResponseCodec, _super);
    function RollbackTransactionSuccessResponseCodec(_config, _response) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._response = _response;
        return _this;
    }
    Object.defineProperty(RollbackTransactionSuccessResponseCodec.prototype, "error", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RollbackTransactionSuccessResponseCodec.prototype, "meta", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    return RollbackTransactionSuccessResponseCodec;
}(RollbackTransactionResponseCodec));
var RollbackTransactionFailureResponseCodec = /** @class */ (function (_super) {
    __extends(RollbackTransactionFailureResponseCodec, _super);
    function RollbackTransactionFailureResponseCodec(_error) {
        var _this = _super.call(this) || this;
        _this._error = _error;
        return _this;
    }
    Object.defineProperty(RollbackTransactionFailureResponseCodec.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RollbackTransactionFailureResponseCodec.prototype, "meta", {
        get: function () {
            throw this._error;
        },
        enumerable: false,
        configurable: true
    });
    return RollbackTransactionFailureResponseCodec;
}(RollbackTransactionResponseCodec));
function isSuccess(obj) {
    // @ts-expect-error
    if (obj.errors != null) {
        return false;
    }
    return true;
}
function isCommitSuccess(obj) {
    // @ts-expect-error
    if (obj.errors != null) {
        return false;
    }
    return true;
}
function isRollbackSuccess(obj) {
    // @ts-expect-error
    if (obj.errors != null) {
        return false;
    }
    return true;
}
